console.log('[CT Bundle Builder] JS actualizado - mostrar disponibles sin filtrar por múltiplo');
(function() {
  var bundleRoot = document.getElementById('ct-bundle-builder');
  if (!bundleRoot) return;

  var MOBILE_BREAKPOINT = 767;

  var packageCards = Array.prototype.slice.call(bundleRoot.querySelectorAll('.ct-package-card'));
  var productGrid = bundleRoot.querySelector('#ct-product-grid');
  var productCards = Array.prototype.slice.call(bundleRoot.querySelectorAll('.ct-product-card'));
  var loadMoreWrap = bundleRoot.querySelector('[data-ct-load-more-wrap]');
  var loadMoreButton = bundleRoot.querySelector('[data-ct-load-more-button]');
  var productsPerPage = parseInt(bundleRoot.getAttribute('data-products-per-page'), 10) || 24;
  var visibleProductCount = 0;
  var loadMoreMeta = null;
  var loadMoreCount = null;
  var loadMoreProgressBar = null;

  var sidebarList = bundleRoot.querySelector('#ct-sidebar-list');
  var sidebarEmpty = bundleRoot.querySelector('#ct-sidebar-empty');
  

  var bundleCount = bundleRoot.querySelector('#ct-bundle-count');
  var bundlePercent = bundleRoot.querySelector('#ct-bundle-percent');
  var bundleMessage = bundleRoot.querySelector('#ct-bundle-message');
  var progressBar = bundleRoot.querySelector('#ct-bundle-progress-bar');

  var cartButton = bundleRoot.querySelector('#ct-cart-button');
  var cartStatus = bundleRoot.querySelector('#ct-cart-status');
  var clearBundleTrigger = bundleRoot.querySelector('[data-ct-clear-bundle-trigger]');

  var packageChangeModal = bundleRoot.querySelector('[data-ct-package-change-modal]');
  var clearBundleModal = bundleRoot.querySelector('[data-ct-clear-bundle-modal]');
  var pendingPackageCard = null;

  var sortTrigger = bundleRoot.querySelector('[data-ct-sort-trigger]');
  var sortMenu = bundleRoot.querySelector('[data-ct-sort-menu]');
  var sortCurrent = bundleRoot.querySelector('[data-ct-sort-current]');
  var sortOptions = Array.prototype.slice.call(bundleRoot.querySelectorAll('.ct-sort-option'));
  var currentSort = 'default';

  var mobileSummaryToggle = bundleRoot.querySelector('[data-ct-mobile-summary-toggle]');
  var mobileSummaryClose = bundleRoot.querySelector('[data-ct-mobile-summary-close]');
  var mobileSummaryPanel = bundleRoot.querySelector('[data-ct-mobile-summary-panel]');
  var mobileSummaryBackdrop = bundleRoot.querySelector('[data-ct-mobile-summary-backdrop]');
  var mobileSummaryCountNodes = Array.prototype.slice.call(bundleRoot.querySelectorAll('[data-ct-mobile-summary-count]'));
  var mobileSummaryPercent = bundleRoot.querySelector('[data-ct-mobile-summary-percent]');
  var mobileSummaryMessage = bundleRoot.querySelector('[data-ct-mobile-summary-message]');
  var mobileProgressBar = bundleRoot.querySelector('[data-ct-mobile-progress-bar]');
  var mobileProgressText = bundleRoot.querySelector('[data-ct-mobile-progress-text]');
  var mobileCartButtons = Array.prototype.slice.call(bundleRoot.querySelectorAll('[data-ct-mobile-cart-button]'));
  var mobileCartStatusNodes = Array.prototype.slice.call(bundleRoot.querySelectorAll('[data-ct-mobile-cart-status]'));
  var mobileClearBundleTrigger = bundleRoot.querySelector('[data-ct-mobile-clear-bundle-trigger]');
  var mobileSidebarList = bundleRoot.querySelector('[data-ct-mobile-sidebar-list]');
  var mobileSidebarEmpty = bundleRoot.querySelector('[data-ct-mobile-sidebar-empty]');

  var cartButtonIncompleteLabel = bundleRoot.getAttribute('data-cart-button-incomplete-label') || 'Completa tu paquete';
  var cartButtonCompleteLabel = bundleRoot.getAttribute('data-cart-button-complete-label') || 'Agregar a carrito';

  var activePackageCard = bundleRoot.querySelector('.ct-package-card.is-active');
var BUNDLE_TARGET = activePackageCard ?
parseInt(activePackageCard.getAttribute('data-bundle-target'), 10) : 120;
var BUNDLE_MULTIPLE = activePackageCard ?
parseInt(activePackageCard.getAttribute('data-bundle-multiple'), 10) : 1;
var activeBundleLabel = activePackageCard ?
activePackageCard.getAttribute('data-bundle-target') + ' pares' : '120 pares';
var activeBundleCartTitle = activePackageCard ?
(activePackageCard.getAttribute('data-bundle-cart-title') || 'CalcetuBox') : 'CalcetuBox';
var activeBundleCartCover = activePackageCard ?
(activePackageCard.getAttribute('data-bundle-cart-cover') || '') : '';
var activeBundleDisplayPrice = activePackageCard ?
(activePackageCard.getAttribute('data-bundle-price') || '') : '';
var activeBundlePriceCents = moneyDisplayToCents(activeBundleDisplayPrice);

if (isNaN(BUNDLE_MULTIPLE) || BUNDLE_MULTIPLE < 1) {
BUNDLE_MULTIPLE = 1;
}

  var STORAGE_KEY = 'ct_bundle_builder_state_v1';
var selectedItems = {};
var isSubmittingCart = false;
var isMobileSummaryOpen = false;
var editBundleId = null;
var isEditMode = false;
var realAvailableStockByProductId = {};
var cartButtonInsufficientLabel = 'Inventario insuficiente';

  function isMobileViewport() {
    return window.innerWidth <= MOBILE_BREAKPOINT;
  }
  function saveBundleState() {
  var state = {
    bundleTarget: BUNDLE_TARGET,
    bundleMultiple: BUNDLE_MULTIPLE,
    activeBundleLabel: activeBundleLabel,
    selectedItems: Object.keys(selectedItems).map(function(productId) {
      return {
        productId: productId,
        qty: selectedItems[productId].qty
      };
    })
  };

  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch (error) {}
}

function clearBundleState() {
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch (error) {}
}

function restoreBundleState() {
  var rawState = null;
  var parsedState = null;

  try {
    rawState = window.localStorage.getItem(STORAGE_KEY);
  } catch (error) {
    return;
  }

  if (!rawState) return;

  try {
    parsedState = JSON.parse(rawState);
  } catch (error) {
    clearBundleState();
    return;
  }

  if (!parsedState || !Array.isArray(parsedState.selectedItems)) {
    clearBundleState();
    return;
  }

  var matchingPackageCard = packageCards.find(function(card) {
    var cardTarget = parseInt(card.getAttribute('data-bundle-target'), 10) || 0;
    var cardMultiple = parseInt(card.getAttribute('data-bundle-multiple'), 10) || 1;
    return cardTarget === parsedState.bundleTarget && cardMultiple === parsedState.bundleMultiple;
  });

  if (matchingPackageCard) {
    applyPackageChange(matchingPackageCard);
  }

  var restoredItems = {};
  var runningTotal = 0;

  parsedState.selectedItems.forEach(function(savedItem) {
    var card = bundleRoot.querySelector('.ct-product-card[data-product-id="' + savedItem.productId + '"]');
    if (!card) return;

    var stock = parseInt(card.getAttribute('data-product-stock'), 10) || 0;
    var qty = parseInt(savedItem.qty, 10) || 0;

    if (qty <= 0 || stock <= 0) return;

    qty = Math.min(qty, stock);

    if (runningTotal + qty > BUNDLE_TARGET) {
      qty = Math.max(0, BUNDLE_TARGET - runningTotal);
    }

    if (qty <= 0) return;

    restoredItems[savedItem.productId] = {
      card: card,
      qty: qty,
      stock: stock
    };

    runningTotal += qty;
    setCardSelected(card, true);
  });

  selectedItems = restoredItems;
}
function getEditBundleIdFromUrl() {
 try {
  var url = new URL(window.location.href);
  return url.searchParams.get('edit_bundle') || '';
 } catch (error) {
  return '';
 }
}

function fetchCartJson() {
 return fetch('/cart.js', {
  method: 'GET',
  headers: {
   'Accept': 'application/json'
  }
 }).then(function(response) {
  if (!response.ok) {
   throw new Error('No se pudo consultar el carrito.');
  }
  return response.json();
 });
}

function findBundleItemsInCart(cart, bundleId) {
 if (!cart || !Array.isArray(cart.items) || !bundleId) return [];
 return cart.items.filter(function(item) {
  return item &&
   item.properties &&
   item.properties._ct_bundle_id &&
   String(item.properties._ct_bundle_id) === String(bundleId);
 });
}
function getBaseStockForCard(card) {
 if (!card) return 0;
 var stock = parseInt(card.getAttribute('data-product-stock'), 10);
 return isNaN(stock) ? 0 : stock;
}

function getReservedQuantitiesFromCart(cart) {
 var reserved = {};

 if (!cart || !Array.isArray(cart.items)) {
  return reserved;
 }

 cart.items.forEach(function(item) {
  if (!item || !item.product_id) return;

  var bundleId =
   item.properties && item.properties._ct_bundle_id
    ? String(item.properties._ct_bundle_id)
    : '';

  if (isEditMode && editBundleId && bundleId && bundleId === String(editBundleId)) {
   return;
  }

  var productId = String(item.product_id);
  var qty = parseInt(item.quantity, 10) || 0;

  reserved[productId] = (reserved[productId] || 0) + qty;
 });

 return reserved;
}

function getAvailableStockForProductId(productId) {
 if (!productId) return 0;

 if (Object.prototype.hasOwnProperty.call(realAvailableStockByProductId, String(productId))) {
  return realAvailableStockByProductId[String(productId)];
 }

 var card = bundleRoot.querySelector('.ct-product-card[data-product-id="' + productId + '"]');
 return getBaseStockForCard(card);
}

function getAvailableStockForCard(card) {
 if (!card) return 0;
 return getAvailableStockForProductId(card.getAttribute('data-product-id'));
}

function refreshSelectedItemStocks() {
 Object.keys(selectedItems).forEach(function(productId) {
  var item = selectedItems[productId];
  if (!item || !item.card) return;
  item.stock = getAvailableStockForCard(item.card);
 });
}

function updateProductCardStockUi(card) {
 if (!card) return;

 var stockNode = card.querySelector('.ct-product-stock');
 if (!stockNode) return;

 var available = getAvailableStockForCard(card);

 stockNode.classList.remove('in-stock', 'out-stock');

 if (available > 0) {
  stockNode.classList.add('in-stock');
  stockNode.textContent = '● En stock - ' + available + ' disponible';
 } else {
  stockNode.classList.add('out-stock');
  stockNode.textContent = 'Agotado';
 }
}

function applyRealStockAvailabilityFromCart(cart) {
 var reserved = getReservedQuantitiesFromCart(cart);
 var nextAvailability = {};

 productCards.forEach(function(card) {
  var productId = String(card.getAttribute('data-product-id') || '');
  var baseStock = getBaseStockForCard(card);
  var reservedQty = reserved[productId] || 0;
  var available = Math.max(0, baseStock - reservedQty);

  nextAvailability[productId] = available;
 });

 realAvailableStockByProductId = nextAvailability;

 productCards.forEach(function(card) {
  updateProductCardStockUi(card);
 });

 refreshSelectedItemStocks();
}

function syncRealStockFromCart() {
 return fetchCartJson()
  .then(function(cart) {
   applyRealStockAvailabilityFromCart(cart);
   return cart;
  })
  .catch(function(error) {
   productCards.forEach(function(card) {
    updateProductCardStockUi(card);
   });
   return null;
  });
}

function getBundleStockIssues() {
 var issues = [];

 Object.keys(selectedItems).forEach(function(productId) {
  var item = selectedItems[productId];
  if (!item || !item.card) return;

  var requestedQty = parseInt(item.qty, 10) || 0;
  var availableQty = getAvailableStockForCard(item.card);
  var title = item.card.getAttribute('data-product-title') || 'este modelo';

  if (requestedQty > availableQty) {
   issues.push({
    productId: productId,
    title: title,
    requestedQty: requestedQty,
    availableQty: availableQty
   });
  }
 });

 return issues;
}

function buildBundleStockIssueMessage(issues) {
 if (!issues || !issues.length) {
  return '';
 }

 if (issues.length === 1) {
  return 'No hay inventario suficiente de "' + issues[0].title + '" para completar este paquete.';
 }

 return 'Uno o más modelos ya no tienen inventario suficiente para completar este paquete.';
}

function validateBundleStockBeforeSubmit() {
 return syncRealStockFromCart().then(function() {
  var issues = getBundleStockIssues();

  if (issues.length) {
   setCartStatus(buildBundleStockIssueMessage(issues), 'is-error');
   renderSidebar();
   return false;
  }

  return true;
 });
}
function applyPackageCardFromBundleItems(bundleItems) {
 if (!bundleItems || !bundleItems.length) return false;

 var bundleTarget = parseInt(
  bundleItems[0].properties && bundleItems[0].properties._ct_bundle_target,
  10
 );

 if (isNaN(bundleTarget) || bundleTarget <= 0) return false;

 var matchingPackageCard = packageCards.find(function(card) {
  var cardTarget = parseInt(card.getAttribute('data-bundle-target'), 10) || 0;
  return cardTarget === bundleTarget;
 });

 if (!matchingPackageCard) return false;

 applyPackageChange(matchingPackageCard);
 return true;
}

function hydrateSelectedItemsFromBundle(bundleItems) {
 var restoredItems = {};
 var runningTotal = 0;

 bundleItems.forEach(function(bundleItem) {
  if (!bundleItem || !bundleItem.product_id) return;

  var productId = String(bundleItem.product_id);
  var qty = parseInt(bundleItem.quantity, 10) || 0;
  if (qty <= 0) return;

  var card = bundleRoot.querySelector(
   '.ct-product-card[data-product-id="' + productId + '"]'
  );
  if (!card) return;

  var stock = parseInt(card.getAttribute('data-product-stock'), 10) || 0;
  if (stock <= 0) return;

  qty = Math.min(qty, stock);

  if (runningTotal + qty > BUNDLE_TARGET) {
   qty = Math.max(0, BUNDLE_TARGET - runningTotal);
  }

  if (qty <= 0) return;

  restoredItems[productId] = {
   card: card,
   qty: qty,
   stock: stock
  };

  runningTotal += qty;
  setCardSelected(card, true);
 });

 selectedItems = restoredItems;
}

function enterEditMode(bundleId) {
 editBundleId = bundleId;
 isEditMode = true;
 bundleRoot.setAttribute('data-ct-edit-mode', 'true');
}

function exitEditMode() {
 editBundleId = null;
 isEditMode = false;
 bundleRoot.removeAttribute('data-ct-edit-mode');
}

function hydrateBuilderFromEditMode() {
 var requestedBundleId = getEditBundleIdFromUrl();

 if (!requestedBundleId) {
  return Promise.resolve(false);
 }

 return fetchCartJson()
  .then(function(cart) {
   var bundleItems = findBundleItemsInCart(cart, requestedBundleId);

   if (!bundleItems.length) {
    throw new Error('No se encontró el paquete a editar en el carrito.');
   }

   clearSelectedItems();
   setCartStatus('', '');

   var packageApplied = applyPackageCardFromBundleItems(bundleItems);
   if (!packageApplied) {
    throw new Error('No se pudo identificar el paquete a editar.');
   }

   hydrateSelectedItemsFromBundle(bundleItems);
   enterEditMode(requestedBundleId);
   applyRealStockAvailabilityFromCart(cart);
   renderSidebar();
   setCartStatus('Estás editando un paquete ya agregado.', 'is-success');

   return true;
  })
  .catch(function(error) {
   exitEditMode();
   clearSelectedItems();
   renderSidebar();
   setCartStatus(
    error.message || 'No se pudo cargar el paquete a editar.',
    'is-error'
   );
   return false;
  });
}

  function normalizeText(value) {
    return (value || '')
      .toString()
      .toLowerCase()
      .trim();
  }

  function getCardTitle(card) {
    return normalizeText(card.getAttribute('data-product-title'));
  }

  function getCardPrice(card) {
    var price = parseInt(card.getAttribute('data-product-price'), 10);
    return isNaN(price) ? 0 : price;
  }

  function getCardPosition(card) {
    var position = parseInt(card.getAttribute('data-product-position'), 10);
    return isNaN(position) ? 0 : position;
  }

  function getCardVisibleIndex(card) {
    var index = parseInt(card.getAttribute('data-product-visible-index'), 10);
    return isNaN(index) ? 0 : index;
  }

  function ensureLoadMoreMeta() {
    if (!loadMoreWrap || loadMoreMeta) return;

    loadMoreMeta = document.createElement('div');
    loadMoreMeta.className = 'ct-load-more-meta';
    loadMoreMeta.innerHTML =
      '<div class="ct-load-more-count"></div>' +
      '<div class="ct-load-more-progress">' +
        '<div class="ct-load-more-progress-bar"></div>' +
      '</div>';

    loadMoreCount = loadMoreMeta.querySelector('.ct-load-more-count');
    loadMoreProgressBar = loadMoreMeta.querySelector('.ct-load-more-progress-bar');

    loadMoreWrap.insertBefore(loadMoreMeta, loadMoreButton);
  }

  function updateLoadMoreVisibility() {
 if (!loadMoreWrap || !loadMoreButton) return;

 ensureLoadMoreMeta();

 var totalProducts = productCards.length;

 var shownProducts = Math.min(visibleProductCount, totalProducts);
 var hasMoreProducts = shownProducts < totalProducts;
 var progressPercent = totalProducts > 0 ? Math.round((shownProducts / totalProducts) * 100) : 0;

 if (loadMoreCount) {
  loadMoreCount.textContent = 'Mostrando ' + shownProducts + ' de ' + totalProducts;
 }

 if (loadMoreProgressBar) {
  loadMoreProgressBar.style.width = progressPercent + '%';
 }

 loadMoreWrap.style.display = totalProducts > 0 ? 'flex' : 'none';
 loadMoreButton.style.display = hasMoreProducts ? 'inline-flex' : 'none';
 loadMoreButton.disabled = !hasMoreProducts;
}

function applyVisibleProducts() {
 var visibleCards = productCards.slice();

 visibleCards.forEach(function(card, index) {
  card.setAttribute('data-product-visible-index', String(index));
 });

 productCards.forEach(function(card) {
  var cardIndex = parseInt(card.getAttribute('data-product-visible-index'), 10) || 0;

  updateProductCardStockUi(card);
  card.style.display = cardIndex < visibleProductCount ? '' : 'none';
 });

 updateLoadMoreVisibility();
}

  function showMoreProducts() {
    visibleProductCount = Math.min(visibleProductCount + productsPerPage, productCards.length);
    applyVisibleProducts();
  }

 function initializeVisibleProducts() {
 visibleProductCount = Math.min(productsPerPage, productCards.length);
 applyVisibleProducts();
}

  function openSortMenu() {
    if (!sortMenu || !sortTrigger) return;
    sortMenu.hidden = false;
    sortTrigger.setAttribute('aria-expanded', 'true');
  }

  function closeSortMenu() {
    if (!sortMenu || !sortTrigger) return;
    sortMenu.hidden = true;
    sortTrigger.setAttribute('aria-expanded', 'false');
  }

  function toggleSortMenu() {
    if (!sortMenu) return;

    if (sortMenu.hidden) {
      openSortMenu();
    } else {
      closeSortMenu();
    }
  }

  function updateSortUI(sortValue) {
    currentSort = sortValue || 'default';

    sortOptions.forEach(function(option) {
      var isActive = option.getAttribute('data-sort-value') === currentSort;
      option.classList.toggle('is-active', isActive);
    });

    var activeOption = bundleRoot.querySelector('.ct-sort-option.is-active');

    if (sortCurrent && activeOption) {
      sortCurrent.textContent = activeOption.textContent.trim();
    }
  }

  function sortProducts(sortValue) {
    if (!productGrid || !productCards.length) return;

    var sortedCards = productCards.slice();

    sortedCards.sort(function(a, b) {
      if (sortValue === 'title-asc') {
        return getCardTitle(a).localeCompare(getCardTitle(b), 'es');
      }

      if (sortValue === 'title-desc') {
        return getCardTitle(b).localeCompare(getCardTitle(a), 'es');
      }

      if (sortValue === 'price-asc') {
        return getCardPrice(a) - getCardPrice(b);
      }

      if (sortValue === 'price-desc') {
        return getCardPrice(b) - getCardPrice(a);
      }

      return getCardPosition(a) - getCardPosition(b);
    });

    sortedCards.forEach(function(card, index) {
      card.setAttribute('data-product-visible-index', String(index));
      productGrid.appendChild(card);
    });

    applyVisibleProducts();
    updateSortUI(sortValue);
  }
function moneyDisplayToCents(value) {
 if (!value) return 0;

 var cleaned = String(value)
 .replace(/[^0-9.,]/g, '')
 .replace(/,/g, '');

 var numberValue = Number(cleaned);

 if (!Number.isFinite(numberValue)) return 0;

 return Math.round(numberValue * 100);
}
  function setCardSelected(card, isSelected) {
    card.setAttribute('data-selected', isSelected ? 'true' : 'false');
    card.classList.toggle('is-selected', isSelected);
  }

  function getTotalUnits() {
    return Object.keys(selectedItems).reduce(function(total, productId) {
      return total + selectedItems[productId].qty;
    }, 0);
  }

  function hasSelectedItems() {
    return Object.keys(selectedItems).length > 0;
  }

  function clearSelectedItems() {
  Object.keys(selectedItems).forEach(function(productId) {
    var item = selectedItems[productId];
    if (item && item.card) {
      setCardSelected(item.card, false);
    }
  });

  selectedItems = {};
  clearBundleState();
}
function resetBuilderAfterAdd(successMessage) {
 exitEditMode();
 clearSelectedItems();

 setCartStatus(
  successMessage || 'Paquete agregado al carrito. Ya puedes armar otro paquete.',
  'is-success'
 );

 renderSidebar();

 syncRealStockFromCart().then(function() {
  initializeVisibleProducts();
  renderSidebar();
 });

 if (isMobileSummaryOpen) {
  closeMobileSummary();
 }

 try {
  window.scrollTo({
   top: bundleRoot.offsetTop || 0,
   behavior: 'smooth'
  });
 } catch (error) {}
}
function refreshCartUiAfterAdd() {
 try {
  document.dispatchEvent(new CustomEvent('cart:refresh', {
   bubbles: true
  }));
 } catch (error) {}

 if (window.theme && window.theme.pubsub && typeof window.theme.pubsub.publish === 'function') {
  try {
   window.theme.pubsub.publish('cart:update', {});
  } catch (error) {}
 }

 if (window.PubSub && typeof window.PubSub.publish === 'function') {
  try {
   window.PubSub.publish('cart:update', {});
  } catch (error) {}
 }

 var cartItems = document.querySelector('cart-items');
 if (cartItems && typeof cartItems.refreshCartItems === 'function') {
  try {
   cartItems.refreshCartItems();
   return;
  } catch (error) {}
 }

 var cartDrawer = document.getElementById('cart-drawer');
 if (cartDrawer && typeof cartDrawer.refreshCartDrawer === 'function') {
  try {
   cartDrawer.refreshCartDrawer();
  } catch (error) {}
 }
}
  function isBundleComplete() {
    return getTotalUnits() === BUNDLE_TARGET;
  }

  function canAddUnits(unitsToAdd) {
    return getTotalUnits() + unitsToAdd <= BUNDLE_TARGET;
  }

  function setCartStatus(message, type) {
    if (cartStatus) {
      cartStatus.textContent = message || '';
      cartStatus.classList.remove('is-error', 'is-success');

      if (type) {
        cartStatus.classList.add(type);
      }
    }

    mobileCartStatusNodes.forEach(function(node) {
      if (!node) return;

      node.textContent = message || '';
      node.classList.remove('is-error', 'is-success');

      if (type) {
        node.classList.add(type);
      }
    });
  }

  function setButtonLoadingState(button, isLoading, completeState, labelOverride) {
 if (!button) return;

 button.classList.toggle('is-loading', isLoading);

 if (isLoading) {
  button.disabled = true;
  button.textContent = 'Agregando...';
  return;
 }

 button.disabled = !completeState;
 button.textContent = labelOverride || (completeState ? cartButtonCompleteLabel : cartButtonIncompleteLabel);
}

  function setCartSubmitting(isLoading) {
    isSubmittingCart = isLoading;

    if (isLoading) {
      setButtonLoadingState(cartButton, true, false);

      mobileCartButtons.forEach(function(button) {
        setButtonLoadingState(button, true, false);
      });
    } else {
      updateSummary();
    }
  }

function buildCartItemsPayload() {
 var bundleId = isEditMode && editBundleId ? editBundleId : ('bundle_' + Date.now());

 return Object.keys(selectedItems).map(function(productId) {
  var item = selectedItems[productId];
  var variantId = item.card.getAttribute('data-variant-id');
  var safeQty = Math.min(item.qty, getAvailableStockForCard(item.card));

  return {
   id: parseInt(variantId, 10),
   quantity: safeQty,
   properties: {
    '_ct_bundle_id': bundleId,
    '_ct_bundle_label': activeBundleLabel,
    '_ct_bundle_target': String(BUNDLE_TARGET),
    '_ct_bundle_card_title': activeBundleCartTitle,
    '_ct_bundle_cover': activeBundleCartCover,
    '_ct_bundle_price_display': activeBundleDisplayPrice,
    '_ct_bundle_price_cents': String(activeBundlePriceCents)
   }
  };
 }).filter(function(item) {
  return !!item.id && item.quantity > 0;
 });
}
function submitBundleItemsToCart(items) {
 return fetch('/cart/add.js', {
  method: 'POST',
  headers: {
   'Content-Type': 'application/json',
   'Accept': 'application/json'
  },
  body: JSON.stringify({ items: items })
 }).then(function(response) {
  if (!response.ok) {
   return response.json().then(function(data) {
    throw new Error(
     data && data.description
      ? data.description
      : 'No se pudo agregar el paquete al carrito.'
    );
   });
  }
  return response.json();
 });
}

function buildPayloadFromCartBundleItems(bundleItems) {
 if (!Array.isArray(bundleItems)) return [];

 return bundleItems.map(function(bundleItem) {
  return {
   id: parseInt(bundleItem.variant_id || bundleItem.id, 10),
   quantity: parseInt(bundleItem.quantity, 10) || 0,
   properties: bundleItem.properties || {}
  };
 }).filter(function(item) {
  return !!item.id && item.quantity > 0;
 });
}

function removeBundleItemsByBundleId(bundleId) {
 if (!bundleId) {
  return Promise.reject(new Error('No se encontró el bundle a reemplazar.'));
 }

 return fetchCartJson().then(function(cart) {
  var bundleItems = findBundleItemsInCart(cart, bundleId);

  if (!bundleItems.length) {
   throw new Error('No se encontró el paquete original en el carrito.');
  }

  var updates = {};
  bundleItems.forEach(function(bundleItem) {
   if (bundleItem && bundleItem.key) {
    updates[bundleItem.key] = 0;
   }
  });

  if (!Object.keys(updates).length) {
   throw new Error('No se pudieron identificar las líneas del paquete original.');
  }

  return fetch('/cart/update.js', {
   method: 'POST',
   headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
   },
   body: JSON.stringify({ updates: updates })
  }).then(function(response) {
   if (!response.ok) {
    throw new Error('No se pudo reemplazar el paquete original.');
   }
   return response.json();
  });
 });
}

function replaceEditedBundleInCart(newItems) {
 if (!isEditMode || !editBundleId) {
  return submitBundleItemsToCart(newItems);
 }

 return fetchCartJson().then(function(cart) {
  var originalBundleItems = findBundleItemsInCart(cart, editBundleId);

  if (!originalBundleItems.length) {
   throw new Error('No se encontró el paquete original en el carrito.');
  }

  var backupItems = buildPayloadFromCartBundleItems(originalBundleItems);

  return removeBundleItemsByBundleId(editBundleId)
   .then(function() {
    return submitBundleItemsToCart(newItems);
   })
   .catch(function(error) {
    if (!backupItems.length) {
      throw error;
    }

    return submitBundleItemsToCart(backupItems)
     .then(function() {
      throw error;
     })
     .catch(function(restoreError) {
      throw new Error(
       (error && error.message ? error.message : 'No se pudo actualizar el paquete.') +
       ' Además, no se pudo restaurar el paquete original.'
      );
     });
   });
 });
}
  function addBundleToCart() {
 if (isSubmittingCart) return;

 if (!isBundleComplete()) {
  setCartStatus('Completa tu paquete antes de continuar.', 'is-error');
  return;
 }

 setCartStatus('', '');
 setCartSubmitting(true);

 validateBundleStockBeforeSubmit().then(function(isValid) {
  if (!isValid) {
   setCartSubmitting(false);
   return;
  }

  var items = buildCartItemsPayload();

  if (!items.length) {
   setCartSubmitting(false);
   setCartStatus('No hay productos para agregar al carrito.', 'is-error');
   return;
  }

  var submitPromise = isEditMode && editBundleId
   ? replaceEditedBundleInCart(items)
   : submitBundleItemsToCart(items);

  submitPromise
   .then(function() {
    setCartSubmitting(false);
    refreshCartUiAfterAdd();
    resetBuilderAfterAdd(
     isEditMode && editBundleId
      ? 'Paquete actualizado correctamente.'
      : 'Paquete agregado al carrito. Ya puedes armar otro paquete.'
    );
   })
   .catch(function(error) {
    setCartSubmitting(false);
    setCartStatus(
     error.message || 'Ocurrió un error al guardar el paquete.',
     'is-error'
    );
   });
 });
}

  function addProduct(card) {
 var productId = card.getAttribute('data-product-id');
 var stock = getAvailableStockForCard(card);
 var initialQty = BUNDLE_MULTIPLE;

 if (!productId) return;
 if (stock <= 0) return;
 if (selectedItems[productId]) return;

 if (initialQty > stock) {
  setCartStatus('No puedes agregar más de ' + stock + ' piezas de ese modelo.', 'is-error');
  return;
 }

 if (!canAddUnits(initialQty)) {
  setCartStatus('No puedes exceder el total del paquete.', 'is-error');
  return;
 }

 selectedItems[productId] = {
  card: card,
  qty: initialQty,
  stock: stock
 };

 setCardSelected(card, true);
 saveBundleState();
 renderSidebar();
}

  function removeProduct(productId) {
  var item = selectedItems[productId];
  if (!item) return;

  setCardSelected(item.card, false);
  delete selectedItems[productId];

  if (!hasSelectedItems()) {
    clearBundleState();
  } else {
    saveBundleState();
  }

  renderSidebar();
}

  function changeQty(productId, delta) {
 var item = selectedItems[productId];
 if (!item) return;

 var realDelta = delta * BUNDLE_MULTIPLE;
 var stock = getAvailableStockForCard(item.card);

 if (delta > 0) {
  if (!canAddUnits(realDelta)) {
   setCartStatus('No puedes exceder el total del paquete.', 'is-error');
   return;
  }

  if (item.qty + realDelta > stock) {
   setCartStatus('No puedes agregar más de ' + stock + ' piezas de ese modelo.', 'is-error');
   return;
  }
 }

 item.qty += realDelta;
 item.stock = stock;

 if (item.qty <= 0) {
  removeProduct(productId);
  return;
 }

 saveBundleState();
 renderSidebar();
}
function buildPlaceholderItem() {
  var item = document.createElement('div');
  item.className = 'ct-placeholder-slot';
  item.textContent = '+';
  return item;
}

function buildSidebarItem(productId, itemData) {
 var card = itemData.card;
 var title = card.getAttribute('data-product-title') || '';
 var image = card.getAttribute('data-product-image') || '';
 var qty = itemData.qty;
 var stock = getAvailableStockForCard(card);
 var canIncrease = canAddUnits(BUNDLE_MULTIPLE) && (qty + BUNDLE_MULTIPLE) <= stock;

 var item = document.createElement('div');
 item.className = 'ct-sidebar-item';
 item.setAttribute('data-sidebar-product-id', productId);
 item.innerHTML =
  '<div class="ct-sidebar-thumb">' +
  (image ? '<img src="' + image + '" alt="' + title.replace(/"/g, '&quot;') + '">' : '') +
  '</div>' +
  '<div class="ct-sidebar-info">' +
  '<div class="ct-sidebar-title">' + title + '</div>' +
  '<div class="ct-qty-row">' +
  '<div class="ct-qty-controls">' +
  '<button type="button" class="ct-qty-btn" data-action="minus" aria-label="Restar">−</button>' +
  '<div class="ct-qty-value">' + qty + '</div>' +
  '<button type="button" class="ct-qty-btn" data-action="plus" aria-label="Sumar"' + (canIncrease ? '' : ' disabled') + '>+</button>' +
  '</div>' +
  '<button type="button" class="ct-sidebar-remove" aria-label="Quitar producto">&times;</button>' +
  '</div>' +
  '</div>';

 var minusBtn = item.querySelector('[data-action="minus"]');
 var plusBtn = item.querySelector('[data-action="plus"]');
 var removeBtn = item.querySelector('.ct-sidebar-remove');

 minusBtn.addEventListener('click', function() {
  setCartStatus('', '');
  changeQty(productId, -1);
 });

 plusBtn.addEventListener('click', function() {
  setCartStatus('', '');
  changeQty(productId, 1);
 });

 removeBtn.addEventListener('click', function() {
  setCartStatus('', '');
  removeProduct(productId);
 });

 return item;
}

  function updateSummary() {
 var totalUnits = getTotalUnits();
 var percentValue = BUNDLE_TARGET > 0 ? Math.min(100, Math.round((totalUnits / BUNDLE_TARGET) * 100)) : 0;
 var missing = BUNDLE_TARGET - totalUnits;
 var stockIssues = getBundleStockIssues();
 var hasStockIssues = stockIssues.length > 0;
 var isComplete = totalUnits === BUNDLE_TARGET;
 var canSubmitBundle = isComplete && !hasStockIssues;
 var stockMessage = buildBundleStockIssueMessage(stockIssues);

 if (bundleCount) {
  bundleCount.textContent = totalUnits + '/' + BUNDLE_TARGET;
 }

 if (bundlePercent) {
  bundlePercent.textContent = percentValue + '%';
 }

 if (progressBar) {
  progressBar.style.width = percentValue + '%';
 }

 if (bundleMessage) {
  if (hasStockIssues) {
   bundleMessage.textContent = stockMessage;
  } else if (missing > 0) {
   bundleMessage.textContent = 'Te faltan ' + missing + ' pares para completar el paquete';
  } else if (missing === 0) {
   bundleMessage.textContent = 'Tu paquete está completo.';
  } else {
   bundleMessage.textContent = 'Tienes ' + Math.abs(missing) + ' pares extra. Ajusta tu paquete para continuar.';
  }
 }

 mobileSummaryCountNodes.forEach(function(node) {
  if (!node) return;
  node.textContent = totalUnits + '/' + BUNDLE_TARGET;
 });

 if (mobileSummaryPercent) {
  mobileSummaryPercent.textContent = percentValue + '%';
 }

 if (mobileProgressBar) {
  mobileProgressBar.style.width = percentValue + '%';
 }

 if (mobileProgressText) {
  mobileProgressText.textContent = percentValue + '%';
 }

 if (mobileSummaryMessage) {
  if (hasStockIssues) {
   mobileSummaryMessage.textContent = stockMessage;
  } else if (missing > 0) {
   mobileSummaryMessage.textContent = 'Te faltan ' + missing + ' pares para completar el paquete';
  } else if (missing === 0) {
   mobileSummaryMessage.textContent = 'Tu paquete está completo.';
  } else {
   mobileSummaryMessage.textContent = 'Tienes ' + Math.abs(missing) + ' pares extra. Ajusta tu paquete para continuar.';
  }
 }

 if (!isSubmittingCart) {
  setButtonLoadingState(
   cartButton,
   false,
   canSubmitBundle,
   hasStockIssues ? cartButtonInsufficientLabel : null
  );

  mobileCartButtons.forEach(function(button) {
   setButtonLoadingState(
    button,
    false,
    canSubmitBundle,
    hasStockIssues ? cartButtonInsufficientLabel : null
   );
  });
 }

 if (clearBundleTrigger) {
  clearBundleTrigger.hidden = !hasSelectedItems();
 }

 if (mobileClearBundleTrigger) {
  mobileClearBundleTrigger.hidden = !hasSelectedItems();
 }
}

  function updateCarousel(card) {
    if (!card) return;

    var carousel = card.querySelector('[data-ct-product-carousel]');
    var track = card.querySelector('[data-ct-carousel-track]');
    if (!carousel || !track) return;

    var count = parseInt(carousel.getAttribute('data-ct-carousel-count'), 10) || 0;
    var index = parseInt(carousel.getAttribute('data-ct-carousel-index'), 10) || 0;
    var prevBtn = card.querySelector('[data-ct-carousel-prev]');
    var nextBtn = card.querySelector('[data-ct-carousel-next]');

    if (count < 2) {
      track.style.transform = 'translateX(0%)';
      return;
    }

    if (index < 0) index = 0;
    if (index > count - 1) index = count - 1;

    carousel.setAttribute('data-ct-carousel-index', String(index));
    track.style.transform = 'translateX(-' + (index * 100) + '%)';

    if (prevBtn) {
      prevBtn.classList.toggle('is-disabled', index === 0);
    }

    if (nextBtn) {
      nextBtn.classList.toggle('is-disabled', index >= count - 1);
    }
  }

  function moveCarousel(card, direction) {
    if (!card) return;

    var carousel = card.querySelector('[data-ct-product-carousel]');
    if (!carousel) return;

    var count = parseInt(carousel.getAttribute('data-ct-carousel-count'), 10) || 0;
    if (count < 2) return;

    var index = parseInt(carousel.getAttribute('data-ct-carousel-index'), 10) || 0;
    index += direction;

    if (index < 0) index = 0;
    if (index > count - 1) index = count - 1;

    carousel.setAttribute('data-ct-carousel-index', String(index));
    updateCarousel(card);
  }

  function initializeCarousels() {
    productCards.forEach(function(card) {
      updateCarousel(card);

      var prevBtn = card.querySelector('[data-ct-carousel-prev]');
      var nextBtn = card.querySelector('[data-ct-carousel-next]');

      if (prevBtn) {
        prevBtn.addEventListener('click', function(event) {
          event.preventDefault();
          event.stopPropagation();
          moveCarousel(card, -1);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function(event) {
          event.preventDefault();
          event.stopPropagation();
          moveCarousel(card, 1);
        });
      }
    });
  }

  function getCatalogStepperMarkup(qty, canIncrease) {
    return '' +
      '<div class="ct-product-stepper">' +
        '<button type="button" class="ct-product-stepper-btn" data-action="minus" aria-label="Restar">−</button>' +
        '<div class="ct-product-stepper-value">' + qty + '</div>' +
        '<button type="button" class="ct-product-stepper-btn" data-action="plus" aria-label="Sumar"' + (canIncrease ? '' : ' disabled') + '>+</button>' +
      '</div>';
  }

  function bindCatalogCardControls(card) {
    if (!card) return;

    var addButton = card.querySelector('.ct-product-add-btn');
    if (addButton) {
      addButton.addEventListener('click', function(event) {
        event.preventDefault();
        event.stopPropagation();
        setCartStatus('', '');
        addProduct(card);
      });
    }

    var stepper = card.querySelector('.ct-product-stepper');
    if (!stepper) return;

    var minusBtn = stepper.querySelector('[data-action="minus"]');
    var plusBtn = stepper.querySelector('[data-action="plus"]');
    var productId = card.getAttribute('data-product-id');

    if (minusBtn) {
      minusBtn.addEventListener('click', function(event) {
        event.preventDefault();
        event.stopPropagation();
        setCartStatus('', '');
        changeQty(productId, -1);
      });
    }

    if (plusBtn) {
      plusBtn.addEventListener('click', function(event) {
        event.preventDefault();
        event.stopPropagation();
        setCartStatus('', '');
        changeQty(productId, 1);
      });
    }
  }

  function updateCatalogButtons() {
 var canAddMore = canAddUnits(BUNDLE_MULTIPLE);

 productCards.forEach(function(card) {
  var productId = card.getAttribute('data-product-id');
  var stock = getAvailableStockForCard(card);
  var selectedItem = selectedItems[productId];
  var currentControl = card.querySelector('.ct-product-card-control');

  if (!currentControl) return;

  currentControl.innerHTML = '';

  if (selectedItem) {
   var qty = selectedItem.qty;
   var canIncrease = canAddUnits(BUNDLE_MULTIPLE) && (qty + BUNDLE_MULTIPLE) <= stock;
   currentControl.innerHTML = getCatalogStepperMarkup(qty, canIncrease);
  } else {
   var addBtn = document.createElement('button');
   addBtn.type = 'button';
   addBtn.className = 'ct-product-add-btn';
   addBtn.textContent = 'Agregar';
   addBtn.disabled = !canAddMore || stock < BUNDLE_MULTIPLE;
   currentControl.appendChild(addBtn);
  }

  bindCatalogCardControls(card);
 });
}

  function renderSidebar() {
  var selectedIds = Object.keys(selectedItems).reverse();
  var placeholderCount = Math.max(0, 3 - selectedIds.length);

  if (sidebarList) {
    sidebarList.innerHTML = '';

    selectedIds.forEach(function(productId) {
      sidebarList.appendChild(buildSidebarItem(productId, selectedItems[productId]));
    });

    for (var i = 0; i < placeholderCount; i++) {
      sidebarList.appendChild(buildPlaceholderItem());
    }
  }


  if (sidebarEmpty) {
    sidebarEmpty.style.display = selectedIds.length === 0 ? 'block' : 'none';
  }

  if (mobileSidebarList) {
    mobileSidebarList.innerHTML = '';

    selectedIds.forEach(function(productId) {
      mobileSidebarList.appendChild(buildSidebarItem(productId, selectedItems[productId]));
    });
  }

  if (mobileSidebarEmpty) {
    mobileSidebarEmpty.style.display = selectedIds.length === 0 ? 'block' : 'none';
  }

  updateSummary();
  updateCatalogButtons();
}

  function applyPackageChange(packageCard) {
 var nextTarget = parseInt(packageCard.getAttribute('data-bundle-target'), 10);
 var nextMultiple = parseInt(packageCard.getAttribute('data-bundle-multiple'), 10);

 packageCards.forEach(function(card) {
  card.classList.remove('is-active');
 });

 packageCard.classList.add('is-active');

 if (!isNaN(nextTarget) && nextTarget > 0) {
  BUNDLE_TARGET = nextTarget;
  activeBundleLabel = nextTarget + ' pares';
 }

 if (!isNaN(nextMultiple) && nextMultiple > 0) {
  BUNDLE_MULTIPLE = nextMultiple;
 } else {
  BUNDLE_MULTIPLE = 1;
 }

 activeBundleCartTitle =
  packageCard.getAttribute('data-bundle-cart-title') || 'CalcetuBox';
 activeBundleCartCover =
  packageCard.getAttribute('data-bundle-cart-cover') || '';
 activeBundleDisplayPrice =
packageCard.getAttribute('data-bundle-price') || '';
activeBundlePriceCents = moneyDisplayToCents(activeBundleDisplayPrice);

 setCartStatus('', '');
 renderSidebar();

 syncRealStockFromCart().then(function() {
  initializeVisibleProducts();
  renderSidebar();
 });
}

  function openPackageChangeModal(packageCard) {
    if (!packageChangeModal) {
      clearSelectedItems();
      applyPackageChange(packageCard);
      return;
    }

    pendingPackageCard = packageCard;
    packageChangeModal.hidden = false;
    document.documentElement.classList.add('ct-modal-open');
  }

  function closePackageChangeModal() {
    if (!packageChangeModal) return;
    packageChangeModal.hidden = true;
    pendingPackageCard = null;
    document.documentElement.classList.remove('ct-modal-open');
  }

  function openClearBundleModal() {
    if (!clearBundleModal) {
      clearSelectedItems();
      setCartStatus('', '');
      renderSidebar();
      return;
    }

    clearBundleModal.hidden = false;
    document.documentElement.classList.add('ct-modal-open');
  }

  function closeClearBundleModal() {
    if (!clearBundleModal) return;
    clearBundleModal.hidden = true;
    document.documentElement.classList.remove('ct-modal-open');
  }

  function openMobileSummary() {
    if (!mobileSummaryPanel) return;

    isMobileSummaryOpen = true;
    bundleRoot.classList.add('is-mobile-summary-open');

    if (mobileSummaryPanel) {
      mobileSummaryPanel.hidden = false;
    }

    if (mobileSummaryBackdrop) {
      mobileSummaryBackdrop.hidden = false;
    }

    if (mobileSummaryToggle) {
      mobileSummaryToggle.setAttribute('aria-expanded', 'true');
    }

    document.documentElement.classList.add('ct-mobile-summary-open');
  }

  function closeMobileSummary() {
    if (!mobileSummaryPanel) return;

    isMobileSummaryOpen = false;
    bundleRoot.classList.remove('is-mobile-summary-open');

    if (mobileSummaryPanel) {
      mobileSummaryPanel.hidden = true;
    }

    if (mobileSummaryBackdrop) {
      mobileSummaryBackdrop.hidden = true;
    }

    if (mobileSummaryToggle) {
      mobileSummaryToggle.setAttribute('aria-expanded', 'false');
    }

    document.documentElement.classList.remove('ct-mobile-summary-open');
  }

  function toggleMobileSummary() {
    if (!mobileSummaryPanel) return;

    if (isMobileSummaryOpen) {
      closeMobileSummary();
    } else {
      openMobileSummary();
    }
  }

  function syncMobileSummaryOnResize() {
    if (!isMobileViewport() && isMobileSummaryOpen) {
      closeMobileSummary();
    }
  }

  packageCards.forEach(function(packageCard) {
    packageCard.addEventListener('click', function() {
      if (hasSelectedItems()) {
        openPackageChangeModal(packageCard);
        return;
      }

      applyPackageChange(packageCard);
    });
  });

  sortOptions.forEach(function(option) {
    option.addEventListener('click', function() {
      var sortValue = option.getAttribute('data-sort-value') || 'default';
      sortProducts(sortValue);
      closeSortMenu();
    });
  });

  if (sortTrigger) {
    sortTrigger.addEventListener('click', function(event) {
      event.preventDefault();
      event.stopPropagation();
      toggleSortMenu();
    });
  }

  if (loadMoreButton) {
    loadMoreButton.addEventListener('click', function() {
      showMoreProducts();
    });
  }

  if (cartButton) {
    cartButton.addEventListener('click', function() {
      addBundleToCart();
    });
  }

  mobileCartButtons.forEach(function(button) {
    if (!button) return;

    button.addEventListener('click', function() {
      addBundleToCart();
    });
  });

  if (clearBundleTrigger) {
    clearBundleTrigger.addEventListener('click', function() {
      if (!hasSelectedItems()) return;
      openClearBundleModal();
    });
  }

  if (mobileClearBundleTrigger) {
    mobileClearBundleTrigger.addEventListener('click', function() {
      if (!hasSelectedItems()) return;
      openClearBundleModal();
    });
  }

  if (mobileSummaryToggle) {
    mobileSummaryToggle.addEventListener('click', function(event) {
      event.preventDefault();
      toggleMobileSummary();
    });
  }

  if (mobileSummaryClose) {
    mobileSummaryClose.addEventListener('click', function(event) {
      event.preventDefault();
      closeMobileSummary();
    });
  }

  if (mobileSummaryBackdrop) {
    mobileSummaryBackdrop.addEventListener('click', function() {
      closeMobileSummary();
    });
  }

  bundleRoot.addEventListener('click', function(event) {
    var cancelPackageChange = event.target.closest('[data-ct-package-change-cancel]');
    if (cancelPackageChange) {
      event.preventDefault();
      closePackageChangeModal();
      return;
    }

    var confirmPackageChange = event.target.closest('[data-ct-package-change-confirm]');
    if (confirmPackageChange) {
      event.preventDefault();

      var packageCard = pendingPackageCard;
      closePackageChangeModal();

      if (packageCard) {
        clearSelectedItems();
        applyPackageChange(packageCard);
      }
      return;
    }

    var cancelClearBundle = event.target.closest('[data-ct-clear-bundle-cancel]');
    if (cancelClearBundle) {
      event.preventDefault();
      closeClearBundleModal();
      return;
    }

    var confirmClearBundle = event.target.closest('[data-ct-clear-bundle-confirm]');
    if (confirmClearBundle) {
      event.preventDefault();
      closeClearBundleModal();
      clearSelectedItems();
      setCartStatus('', '');
      renderSidebar();
    }
  });

  document.addEventListener('click', function(event) {
 if (sortMenu && sortTrigger && !sortMenu.hidden &&
 !event.target.closest('.ct-sort-wrap')) {
  closeSortMenu();
 }
});

  window.addEventListener('resize', function() {
    syncMobileSummaryOnResize();
  });

  document.addEventListener('keydown', function(event) {
 if (event.key !== 'Escape') return;
 if (packageChangeModal && !packageChangeModal.hidden) {
  closePackageChangeModal();
 }
 if (clearBundleModal && !clearBundleModal.hidden) {
  closeClearBundleModal();
 }
 if (sortMenu && !sortMenu.hidden) {
  closeSortMenu();
 }
 if (mobileSummaryPanel && isMobileSummaryOpen) {
  closeMobileSummary();
 }
});

  updateSortUI(currentSort);
initializeCarousels();
initializeVisibleProducts();

hydrateBuilderFromEditMode()
 .then(function(wasHydratedFromEdit) {
  if (!wasHydratedFromEdit) {
   restoreBundleState();
   renderSidebar();
  } else {
   renderSidebar();
  }

  return syncRealStockFromCart();
 })
 .then(function() {
  initializeVisibleProducts();
  renderSidebar();
 });

syncMobileSummaryOnResize();
})();